import { Pagination } from 'react-bootstrap';

export const PaginationMenu = (props) => {
  const handlePageChange = pageNumber => {
    if (pageNumber < 1) {
      pageNumber = 1;
    }

    if (pageNumber > props.totalPages) {
      pageNumber = props.totalPages;
    }

    props.setCurrentPage(pageNumber);

    const url = new URL(window.location.toString());
    url.searchParams.set('pagina', String(pageNumber));

    window.history.pushState({}, '', url);
  };

  return (
    <>
      {props.totalPages <= 5 && (
        <div className="d-flex justify-content-center">
          <Pagination>
            {Array.from({ length: props.totalPages }).map((item, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === Number(props.currentPage)}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      )}
      {props.totalPages > 5 && (
        <div className="d-flex justify-content-center">
          <Pagination>
            <Pagination.First disabled={Number(props.currentPage) === 1 ? true : false} onClick={() => handlePageChange(1)} />
            <Pagination.Prev disabled={Number(props.currentPage) === 1 ? true : false} onClick={() => handlePageChange(Number(props.currentPage) - 1)} />
            <Pagination.Item
              active={1 === Number(props.currentPage)}
              onClick={() => handlePageChange(1)}
            >{1}
            </Pagination.Item>
            <Pagination.Ellipsis disabled />

            {Number(props.currentPage) === 1 && (
              <>
                <Pagination.Item
                  active={Math.ceil(props.totalPages / 2) - 1 === Number(props.currentPage)}
                  onClick={() => handlePageChange(Math.ceil(props.totalPages / 2) - 1)}
                >{Math.ceil(props.totalPages / 2) - 1}
                </Pagination.Item>
                <Pagination.Item
                  active={Math.ceil(props.totalPages / 2) === Number(props.currentPage)}
                  onClick={() => handlePageChange(Math.ceil(props.totalPages / 2))}
                >{Math.ceil(props.totalPages / 2)}
                </Pagination.Item>
                <Pagination.Item
                  active={Math.ceil(props.totalPages / 2) + 1 === Number(props.currentPage)}
                  onClick={() => handlePageChange(Math.ceil(props.totalPages / 2) + 1)}
                >{Math.ceil(props.totalPages / 2) + 1}
                </Pagination.Item>
              </>
            )}

            {Number(props.currentPage) > 1 && Number(props.currentPage) < props.totalPages - 2 && (
              <>
                <Pagination.Item
                  active={Number(props.currentPage)}
                  onClick={() => handlePageChange(Number(props.currentPage))}
                >{Number(props.currentPage)}
                </Pagination.Item>
                <Pagination.Item
                  active={Number(props.currentPage) + 1 === Number(props.currentPage)}
                  onClick={() => handlePageChange(Number(props.currentPage) + 1)}
                >{Number(props.currentPage) + 1}
                </Pagination.Item>
                <Pagination.Item
                  active={Number(props.currentPage) + 2 === Number(props.currentPage)}
                  onClick={() => handlePageChange(Number(props.currentPage) + 2)}
                >{Number(props.currentPage) + 2}
                </Pagination.Item>
              </>
            )}

            {Number(props.currentPage) >= props.totalPages - 2 && (
              <>
                <Pagination.Item
                  active={props.totalPages - 3 === Number(props.currentPage)}
                  onClick={() => handlePageChange(props.totalPages - 3)}
                >{props.totalPages - 3}
                </Pagination.Item>
                <Pagination.Item
                  active={props.totalPages - 2 === Number(props.currentPage)}
                  onClick={() => handlePageChange(props.totalPages - 2)}
                >{props.totalPages - 2}
                </Pagination.Item>
                <Pagination.Item
                  active={props.totalPages - 1 === Number(props.currentPage)}
                  onClick={() => handlePageChange(props.totalPages - 1)}
                >{props.totalPages - 1}
                </Pagination.Item>
              </>
            )}

            <Pagination.Ellipsis disabled />
            <Pagination.Item
              active={props.totalPages === Number(props.currentPage)}
              onClick={() => handlePageChange(props.totalPages)}
            >{props.totalPages}
            </Pagination.Item>
            <Pagination.Next disabled={Number(props.currentPage) === props.totalPages ? true : false} onClick={() => handlePageChange(Number(props.currentPage) + 1)} />
            <Pagination.Last disabled={Number(props.currentPage) === props.totalPages ? true : false} onClick={() => handlePageChange(props.totalPages)} />
          </Pagination>
        </div>
      )}
    </>
  )
}
